module.exports = __webpack_public_path__ + "images/140_320.jpg";